export default "__VITE_ASSET__CAmZyAE$__"